import { create } from 'zustand';
import { formatISO } from 'date-fns';

const EMPTY_FORM = {
  date: formatISO(new Date(), { representation: 'date' }),
  time: '09:00',
  customerId: '',
  employeeId: '',
  status: 'approved',
  notes: '',
  paymentMethod: 'Nakit',
  selectedCustomer: null,
  selectedEmployee: null,
};

/**
 * appointments feature UI state.
 * Firestore verisi (appointments, customers, vb.) burada YAŞAMAZ.
 */
const useAppointmentsStore = create((set) => ({
  // ── Takvim görünümü ────────────────────────────────────────
  viewedMonth:      new Date(),
  calendarViewMode: 'monthly', // 'monthly' | 'weekly'
  setViewedMonth:      (date) => set({ viewedMonth: date }),
  setCalendarViewMode: (mode) => set({ calendarViewMode: mode }),

  // ── Seçili gün ────────────────────────────────────────────
  selectedDate:         null,
  selectedAppointments: [],
  setSelectedDate:         (date)  => set({ selectedDate: date }),
  setSelectedAppointments: (list)  => set({ selectedAppointments: list }),
  clearSelectedDate: () => set({ selectedDate: null, selectedAppointments: [] }),

  // ── Tooltip ───────────────────────────────────────────────
  showTooltip:    false,
  setShowTooltip: (v) => set({ showTooltip: v }),

  // ── Randevu Modal ─────────────────────────────────────────
  isModalOpen:         false,
  isEditing:           false,
  currentAppointmentId: null,
  appointmentForm:     EMPTY_FORM,
  selectedServices:    [],
  isSaving:            false,

  setAppointmentForm: (formOrUpdater) =>
    set((state) => ({
      appointmentForm:
        typeof formOrUpdater === 'function'
          ? formOrUpdater(state.appointmentForm)
          : formOrUpdater,
    })),
  setSelectedServices: (v)  => set({ selectedServices: v }),
  setIsSaving:         (v)  => set({ isSaving: v }),

  openModal: () =>
    set({
      isModalOpen:          true,
      isEditing:            false,
      currentAppointmentId: null,
      appointmentForm:      {
        ...EMPTY_FORM,
        date: formatISO(new Date(), { representation: 'date' }),
      },
      selectedServices: [],
    }),

  openEditModal: ({ appointmentId, form, services }) =>
    set({
      isModalOpen:          true,
      isEditing:            true,
      currentAppointmentId: appointmentId,
      appointmentForm:      form,
      selectedServices:     services,
    }),

  closeModal: () =>
    set({
      isModalOpen:          false,
      isEditing:            false,
      currentAppointmentId: null,
    }),

  // ── Silme onayı ───────────────────────────────────────────
  deleteConfirmOpen:  false,
  appointmentToDelete: null,
  openDeleteConfirm:  (appt) => set({ deleteConfirmOpen: true, appointmentToDelete: appt }),
  closeDeleteConfirm: ()     => set({ deleteConfirmOpen: false, appointmentToDelete: null }),

  // ── Adisyon onayı ─────────────────────────────────────────
  billConfirmOpen:    false,
  appointmentToBill:  null,
  openBillConfirm:    (appt) => set({ billConfirmOpen: true, appointmentToBill: appt }),
  closeBillConfirm:   ()     => set({ billConfirmOpen: false, appointmentToBill: null }),

  // ── Aksiyon yüklenme ──────────────────────────────────────
  actionLoading: null,
  setActionLoading: (v) => set({ actionLoading: v }),
}));

export default useAppointmentsStore;
